import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
interface ServiceCardItem {
  title: string;
  description: string;
  linkText: string;
  to: string;
}
const serviceCards: ServiceCardItem[] = [{
  title: "Badrumsrenovering Karlstad",
  description: "Planerar du att renovera badrummet i Karlstad, Hammarö, Skåre eller närliggande områden? Vi erbjuder kostnadsfria hembesök, fasta priser och auktoriserat VVS-arbete utfört enligt Säker Vattens branschregler.",
  linkText: "Läs mer om badrumsrenovering i Karlstad →",
  to: "/badrumsrenovering-karlstad"
}, {
  title: "Badrumsrenovering Arvika",
  description: "För dig i Arvika och västra Värmland erbjuder vi komplett totalentreprenad. Vi tar helhetsansvar från planering och rivning till färdigt badrum med behörig plattsättning och giltigt våtrumsintyg.",
  linkText: "Läs mer om badrumsrenovering i Arvika →",
  to: "/badrumsrenovering-arvika"
}, {
  title: "Inspiration & Materialval",
  description: "Vill du samla inspiration kring moderna material, stora klinkerplattor, integrerade nischer eller tidlös skandinavisk design? Utforska våra tidigare projekt och få konkreta idéer inför ditt val av badrumsinredning.",
  linkText: "Se vårt badrumsgalleri & inspiration →",
  to: "/inspiration"
}];
export default function LocalServices() {
  return <section id="localservicesandinspiration" data-nav="light" className="bg-muted/40 text-foreground py-[60px]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading & Intro */}
        <div className="mx-auto max-w-3xl text-center mb-10">
          <h2 className="font-bold tracking-tight text-foreground !text-4xl">
            Totalentreprenad och badrumsrenovering i hela Värmland
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground max-w-[780px] mx-auto">
            Vi hjälper villaägare och bostadsrättsinnehavare i hela länet med helhetslösningar. Alla yrkesgrupper – från rivning och VVS till tätskikt och elinstallation – samordnas under ett och samma tak. Välj ditt område nedan för att läsa mer om våra lokala tjänster:
          </p>
        </div>

        {/* 3-Column Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {serviceCards.map((card, index) => <Card key={card.title} data-index={index} className="bg-card text-card-foreground border border-border rounded-lg p-6 shadow-sm flex flex-col justify-between transition-transform duration-200 hover:-translate-y-1">
              <div>
                <CardHeader className="p-0 mb-3">
                  <CardTitle className="text-lg font-semibold text-primary leading-snug">
                    <h3 className="text-lg font-semibold text-primary">{card.title}</h3>
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {card.description}
                  </p>
                </CardContent>
              </div>

              <CardFooter className="p-0 pt-6">
                <Link to={card.to} className="inline-flex items-center text-sm font-medium text-primary hover:underline group">
                  {card.linkText}
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}